import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import es from './locales/es.json';
import it from './locales/it.json';
import pt from './locales/pt.json';
import { SUPPORTED_LANGUAGES } from './types';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      de: { translation: de },
      es: { translation: es },
      it: { translation: it },
      pt: { translation: pt },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES as readonly string[] as string[],
    interpolation: { escapeValue: false },
    // Without this, a missing key renders as its raw path ("detail.booking.book")
    // with nothing logged — invisible to tsc and to the e2e suite. Routing it to
    // console.error trips the trap in e2e/fixtures.ts, so pruning or mistyping a
    // key fails the tests instead of shipping.
    saveMissing: true,
    missingKeyHandler: (lngs, ns, key) => {
      console.error(`i18n: missing key "${key}" in "${ns}" for [${lngs.join(', ')}]`);
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'takuna-lang',
    },
  });

i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
});

export default i18n;
